import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import { getToken } from '@/utils/auth'; // get token from cookie

import { Message } from 'element-ui';

/**
 * @param {*} obj 请求配置
 */
axios.defaults.timeout = 100 * 1000;
axios.defaults.baseURL = "/".concat(process.env.VUE_APP_SERVER_PREFIX);
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.message.includes('timeout')) {
    // 判断请求异常信息中是否含有超时timeout字符串
    Message.warning('请求超时！');
    return Promise.reject(error); // reject这个错误信息
  }

  return Promise.reject(error);
});
var axiosRequest = function axiosRequest(obj) {
  return axios(obj).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(res.status === 200 && res.data)) {
                _context.next = 9;
                break;
              }
              // token过期在interceptors中处理
              if (res.data.code && res.data.code !== 200 && res.data.code !== 'SUC000000' && res.data.code !== '0000000' && res.data.code !== '0000000000') {
                Message({
                  message: res.data.message,
                  type: 'warning'
                });
              }
              if (!(res.config.responseType === 'blob')) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", res);
            case 6:
              return _context.abrupt("return", res.data);
            case 7:
              _context.next = 10;
              break;
            case 9:
              return _context.abrupt("return", {
                error_code: -1,
                error_msg: res.message || res.msg || '获取失败'
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()).catch(function (e) {
    if (e.response) {
      return {
        error_code: -1,
        error_msg: "\u7F51\u7EDC\u5F02\u5E38 \uFF1A".concat(e.response.status)
      };
    } else {
      return {
        error_code: -1,
        error_msg: '网络异常'
      };
    }
  });
};
/**
 * @param {Object} config 请求配置
 */
var getData = function getData(config) {
  if (config.url.indexOf('http') !== 0) {
    // config.url = CONSTANTS.API_BASE + config.url
    // config.baseURL = CONSTANTS.API_BASE
  }
  var requestData = {
    method: config.method || 'GET',
    url: config.url,
    params: config.data || {},
    data: {},
    responseType: config.responseType || 'json',
    headers: config.headers || {},
    Authorization: getToken()
  };
  if (config.url.indexOf('userLogin') < 0) {
    requestData.headers.Authorization = "bearer ".concat(getToken());
    requestData.headers.requestSource = 'PC_WEB';
    requestData.headers.systemId = 'LC_PLATFORM';
    requestData.headers.userId = 'admin';
    // console.log('requestData',requestData)
  }

  // if (requestData.method.toLowerCase() === 'get') {
  //   // for (let key in config.data) {
  //   //    requestData.url = requestData.url + '/' + config.data[key]
  //   //  }
  //   requestData.params = {
  //     ...config.data
  //   }
  // } else {
  //   requestData.params = {
  //     ...config.data
  //   }
  // }
  if (config.method === 'POST' || config.method === 'DELETE') {
    requestData.params = {};
    requestData.data = config.data;
  }
  if (config.method === 'PUT') {
    requestData.params = {};
    requestData.data = config.data;
  }
  if (config.url.indexOf('oauth/tokenInfo') > -1) {
    requestData.headers.token = sessionStorage.getItem('token');
  }
  return axiosRequest(requestData);
  // 需要登录态
  // if (needLogin) {
  //   // APP 外传入token
  //   let requestData = {
  //     method: config.method || 'get',
  //     url: config.url,
  //     data: {
  //       ...config.data,
  //     },
  //     params: config.params || {},
  //     responseType: 'json',
  //     headers: config.headers || {}
  //   }
  //   return axiosRequest(requestData)
  // } else {
  //   let dd = {
  //     method: config.method || 'get',
  //     url: config.url,
  //     data: {
  //       ...config.data
  //     },
  //   }
  //   return axiosRequest(dd)
  // }
};

export default getData;